import script from "./RefundCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RefundCard.vue?vue&type=script&setup=true&lang=js"

import "./RefundCard.vue?vue&type=style&index=0&id=0188e0eb&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0188e0eb"]])

export default __exports__